import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import CommentThread from '../../../CommentThread';
import DisabledComment from '../../../DisabledComment';
import { getCommentableTypeForDeviationType } from '../../redux/helpers';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import PremiumGallery from '@wix/da-ds/pkg/Icons/24x24/PremiumGallery';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/16x16/EyeDisc2';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { isImageDeviation } from '../../../DeviationViews/_helpers';
import s from './Comments.scss';
export const COMMENTS_HTML_ID = 'comments';
export const Comments = ({ deviation: { deviationId, typeId, isCommentable, hasPrivateComments }, deviation, isOwner, className })=>{
    var _deviation;
    const { t } = useTranslation();
    const commentableTypeId = getCommentableTypeForDeviationType(typeId);
    const { isPremium, isPaidFolder } = normalizePremiumFolderData((_deviation = deviation) === null || _deviation === void 0 ? void 0 : _deviation.premiumFolderData);
    const ownerInfo = isOwner && isPremium && hasPrivateComments && /*#__PURE__*/ React.createElement("div", {
        className: s['owner-info-wrapper']
    }, isPaidFolder ? /*#__PURE__*/ React.createElement(PremiumGallery, {
        size: IconSize.TINY
    }) : /*#__PURE__*/ React.createElement(EyeDisc2, {
        size: IconSize.TINY
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['owner-info']
    }, t(isPaidFolder ? 'deviation.comments.paywallOwner.premium' : 'deviation.comments.paywallOwner.watchers_only')));
    const withCommentSuggestions = isImageDeviation(deviation) && !isOwner ? 'deviation' : undefined;
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "Comments"
    }, /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            sectionname: 'comments'
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['comments-anchor'],
        id: COMMENTS_HTML_ID
    }), /*#__PURE__*/ React.createElement(CommentThread, {
        key: `${commentableTypeId}:${deviationId}`,
        commentableTypeId: commentableTypeId,
        commentableItemId: deviationId,
        postbox: isCommentable ? 'both' : 'none',
        statsAndControls: "on",
        className: className,
        allowSelfInit: false,
        enableOffsetTracking: true,
        extraInHeader: ownerInfo,
        withCommentSuggestions: withCommentSuggestions,
        isSticky: true
    }), !isCommentable && /*#__PURE__*/ React.createElement(DisabledComment, {
        className: classnames(s['comments-disabled'], className),
        title: t('deviation.comments.commentsDisabled')
    })));
};
Comments.displayName = 'Comments';
export default Comments;
